var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"news-item"},[_c('p',{staticClass:"news-item-title"},[_c('a',{attrs:{"href":_vm.item.url}},[_vm._v(_vm._s(_vm.item.title))]),_c('span',{staticClass:"domain"},[_vm._v(" ("+_vm._s(_vm.item.domain)+")")])]),_c('p',{staticClass:"news-item-details"},[_vm._v("\n    "+_vm._s(_vm.item.points)+" points by "+_vm._s(_vm.item.user)+" "+_vm._s(_vm.item.time_ago)+" |\n    "),_c('router-link',{attrs:{"to":{
        name: 'news-item',
        params: {
          id: _vm.item.id,
        }
      }}},[_vm._v(_vm._s(_vm.item.comments_count)+" comments")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }